import { useMutation } from 'react-query';
import { BASE_URL, ERROR_MESSAGE } from 'constants/index';

export const useFetch = () => {
  const { mutate: sendToEmailMutation } = useMutation<void, Error, any>({
    mutationFn: async (data) => {
      const response = await fetch(`${BASE_URL}/submit_email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-ID': `${data.sessionKey}`,
        },
        body: JSON.stringify({ email: data.email }),
      });
      if (!response.ok) throw new Error(ERROR_MESSAGE);
      return response.json();
    },
    onError: (e) => {
      console.error('Error send to email:', e);
    },
  });

  return {
    sendToEmailMutation,
  };
};
